<template>
  <v-container fluid>
    <!-- แจ้งเตือนรายงานตัวครูผู้ช่วย -->
    <v-card
      class="hrvec-alert-card mb-3"
      v-if="periodassteachTeachers.periodAssTeachEnable === '1' || periodassteachTeachers.periodAssTeachEnable === 1"
    >
      <div class="hrvec-priority-bar normal"></div>
      <v-card-text class="pa-0">
        <v-row no-gutters align="center">
          <v-col cols="12" md="8" class="hrvec-card-content-col">
            <div class="d-flex align-start">
              <div class="hrvec-icon-wrap mr-3" style="background: #2e7d32">
                <v-icon size="20" color="white">mdi-account-school</v-icon>
              </div>
              <div>
                <h3 class="hrvec-card-title">
                  รายงานตัวครูผู้ช่วย ก่อนเลือกสถานศึกษา
                </h3>
                <p class="hrvec-card-subtitle mt-1 mb-0">
                  สามารถดำเนินการรายงานตัว ก่อนระบบปิด
                </p>
                <div class="mt-3 d-flex align-center">
                  <v-btn
                    rounded depressed color="success" dark
                    class="hrvec-action-button"
                    to="/pages/manage_assistant_teacher"
                  >
                    <v-icon small left>mdi-page-next</v-icon>
                    ดำเนินการรายงานตัว
                  </v-btn>
                  <v-btn
                    icon color="error"
                    @click="VideoDialog()"
                    class="ml-2"
                  >
                    <v-icon>mdi-play-circle</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="4" class="hrvec-card-countdown-col">
            <div class="hrvec-card-countdown">
              <div class="hrvec-countdown-label">ปิดระบบ</div>
              <div class="hrvec-countdown-date">
                {{ periodassteachTeachers.periodAssTeachStop | moment("add", "543 years") | moment("D MMMM YYYY") }}
              </div>
              <div
                class="hrvec-countdown-flip-wrap mt-2"
                v-if="timeRemaining && timeRemaining.totalMs > 0"
              >
                <flip-countdown
                  :deadline="periodassteachTeachers.periodAssTeachStop + ' 16:30:00'"
                  :labels="labels"
                ></flip-countdown>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Summary Info Card -->
    <v-card class="summary-info-card " outlined v-if="periodassteachTeachers.periodAssTeachEnable === '1' || periodassteachTeachers.periodAssTeachEnable === 1">
      <v-card-title class="pb-2">
        <v-icon color="info" class="mr-2">mdi-information</v-icon>
        ข้อมูลระบบรายงานตัวครูผู้ช่วย
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <div class="info-item">
              <v-icon color="primary" class="mr-2">mdi-calendar-check</v-icon>
              <div>
                <strong>สถานะระบบ:</strong>
                <v-chip
                  :color="periodassteachTeachers.periodAssTeachEnable === '1' || periodassteachTeachers.periodAssTeachEnable === 1 ? 'success' : 'grey'"
                  text-color="white"
                  small
                  class="ml-2"
                >
                  {{ periodassteachTeachers.periodAssTeachEnable === '1' || periodassteachTeachers.periodAssTeachEnable === 1 ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
                </v-chip>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" v-if="periodassteachTeachers.periodAssTeachStop">
            <div class="info-item">
              <v-icon color="warning" class="mr-2">mdi-clock-outline</v-icon>
              <div>
                <strong>วันที่ปิดระบบ:</strong><br>
                <span class="deadline-text">
                  {{ periodassteachTeachers.periodAssTeachStop | moment("add", "543 years") | moment("D MMMM YYYY") }}
                </span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="info-item">
              <v-icon color="info" class="mr-2">mdi-account-group</v-icon>
              <div>
                <strong>กลุ่มเป้าหมาย:</strong><br>
                <span>ครูผู้ช่วยที่ได้รับการบรรจุ</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Video Dialog -->
    <v-dialog v-model="VideoDialogYoutube" max-width="800px">
      <v-card>
        <v-card-title class="flex-between">
          <span class="headline">คู่มือการรายงานตัวครูผู้ช่วย</span>
          <v-btn icon @click="VideoDialogYoutubeStop()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="video-container">
            <p class="text-center text-muted">
              วิดีโอแนะนำขั้นตอนการรายงานตัวครูผู้ช่วยจะแสดงที่นี่
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      <v-icon v-if="snackbar.icon" left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "AssistantTeacherAlert",
  components: { FlipCountdown },
  
  data() {
    return {
      loading: false,
      VideoDialogYoutube: false,
      ApiKey: "HRvec2021",
      periodassteachTeachers: {},
      periodassteach_38: [],
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      }
    };
  },

  async mounted() {
    await this.loadData();
  },

  methods: {
    async loadData() {
      this.loading = true;
      try {
        await this.periodassteachQueryTeacher();
        this.showSnackbar('โหลดข้อมูลสำเร็จ', 'success', 'mdi-check-circle');
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการโหลดข้อมูล', 'error', 'mdi-alert-circle');
        console.error('Error loading data:', error);
      } finally {
        this.loading = false;
      }
    },

    async periodassteachQueryTeacher() {
      try {
        let result = await this.$http.post("periodassteach.php", {
          ApiKey: this.ApiKey,       
          periodAssTeachID: "103"
        });
        this.periodassteachTeachers = result.data;   
      } catch (error) {
        console.error('Error fetching period data:', error);
        throw error;
      }
    },

    async VideoDialog() {
      this.VideoDialogYoutube = true;
    },

    async VideoDialogYoutubeStop() {
      // หยุดวิดีโอทั้งหมด
      const videos = document.querySelectorAll("iframe, video");
      Array.prototype.forEach.call(videos, function(video) {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          const src = video.src;
          video.src = src;
        }
      });
      this.VideoDialogYoutube = false;
    },

    showSnackbar(text, color = 'info', icon = 'mdi-information') {
      this.snackbar = {
        show: true,
        text,
        color,
        icon,
        timeout: 5000
      };
    },

    // Method สำหรับรีเฟรชข้อมูล
    async refreshData() {
      await this.loadData();
    }
  },

  computed: {
    isSystemActive() {
      return this.periodassteachTeachers.periodAssTeachEnable === '1' || this.periodassteachTeachers.periodAssTeachEnable === 1;
    },

    timeRemaining() {
      if (!this.periodassteachTeachers.periodAssTeachStop) return null;
      
      const now = new Date();
      const deadline = new Date(this.periodassteachTeachers.periodAssTeachStop + ' 16:30:00');
      const diff = deadline - now;
      
      if (diff <= 0) return null;
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      
      return { days, hours, totalMs: diff };
    },

    urgencyLevel() {
      if (!this.timeRemaining) return 'expired';
      
      const { days } = this.timeRemaining;
      if (days <= 1) return 'critical';
      if (days <= 3) return 'high';
      if (days <= 7) return 'medium';
      return 'low';
    }
  },

  watch: {
    // เฝ้าดูการเปลี่ยนแปลงของข้อมูล
    'periodassteachTeachers.periodAssTeachEnable'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        const message = newVal === '1' || newVal === 1 ? 'ระบบรายงานตัวได้เปิดใช้งานแล้ว' : 'ระบบรายงานตัวได้ปิดใช้งานแล้ว';
        const color = newVal === '1' || newVal === 1 ? 'success' : 'warning';
        this.showSnackbar(message, color, 'mdi-bell-ring');
      }
    }
  }
};
</script>

<style scoped>
/* Alert Dashboard Styles */
.assistant-teacher-alert {
  margin-bottom: 24px;
}

/* Alert Cards */
.alert-card {
  border-radius: 15px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.alert-card:hover {
  transform: translateY(-3px);
}

.alert-card.on-hover {
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}

.inactive-card {
  background: #fafafa;
}

.alert-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
}

.success-stripe {
  background: linear-gradient(to bottom, #2e7d32, #2e7d32);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

.alert-content {
  padding-left: 10px;
}

.alert-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.alert-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #263238;
  margin-bottom: 5px;
  line-height: 1.3;
}

.alert-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.4;
  margin: 0;
}

.deadline-text {
  font-size: 0.95rem;
  color: #f44336;
  font-weight: 500;
}

.alert-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 15px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.countdown-timer {
  margin-bottom: 10px;
}

.action-btn {
  border-radius: 10px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-width: 180px;
}

.action-btn:hover {
  transform: translateY(-2px);
}

.video-btn {
  border-radius: 50% !important;
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
}

/* Summary Info Card */
.summary-info-card {
  border-radius: 10px !important;
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.info-item:last-child {
  margin-bottom: 0;
}

/* Countdown Timer Styles */
.countdown-timer >>> .flip-countdown {
  font-family: "Roboto", sans-serif;
}

.countdown-timer >>> .flip-countdown__piece {
  background: #2e7d32;
  color: white;
  border-radius: 5px;
  font-size: 0.9rem;
  min-width: 35px;
  height: 35px;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.7rem;
  color: #666;
  margin-top: 5px;
}

/* Video Dialog */
.video-container {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 10px;
}

/* Utility classes */
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-muted {
  color: #666 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .alert-title {
    font-size: 1.2rem;
  }

  .alert-description {
    font-size: 0.9rem;
  }

  .alert-actions {
    margin-top: 20px;
  }

  .countdown-timer >>> .flip-countdown__piece {
    min-width: 30px;
    height: 30px;
    font-size: 0.8rem;
  }

  .action-btn {
    min-width: 140px;
  }
}

@media (max-width: 600px) {
  .alert-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .alert-header .v-icon {
    margin-bottom: 10px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-item .v-icon {
    margin-bottom: 5px;
  }
}

/* Animation Effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-card {
  animation: fadeInUp 0.6s ease-out;
}

.summary-info-card {
  animation: fadeInUp 0.6s ease-out;
  animation-delay: 0.2s;
  animation-fill-mode: both;
}

/* Vue transitions */
.v-application {
  font-family: "Sarabun", "Roboto", sans-serif !important;
}

.v-btn {
  text-transform: none !important;
  font-weight: 500 !important;
}

.v-card {
  transition: all 0.3s ease !important;
}

/* Focus states for accessibility */
.action-btn:focus {
  outline: 2px solid #2e7d32;
  outline-offset: 2px;
}

.alert-card:focus-within {
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.3);
}
</style>
